import React from "react";
import styled from "@emotion/styled";
import { row } from "@ui/style/layout";
import { DialogProps } from "primereact/dialog";
import { BaseDialog } from "@ui/components/dialog/base-dialog";
import { FilterListingPanel } from "@ui/pages/exercise/components/filter-listing-panel";

export type ExerciseFiltersDialogProps = DialogProps;

export const ExerciseFiltersDialog: React.FC<ExerciseFiltersDialogProps> = props => (
	<StyledBaseDialog {...props} tabletSameAsMobile>
		<FilterListingPanel />
	</StyledBaseDialog>
);

const StyledBaseDialog = styled(BaseDialog)`
	& .p-dialog-header {
		${row()};
		padding-right: 5px;
		padding-bottom: 5px;
	}

	& .p-dialog-header:after {
		display: none;
	}

	& .p-dialog-content {
		padding-top: 0;
	}
`;
